// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-page {
  padding: 0;
  width: 100%;
}

.about-container {
  max-width: 800px;
  margin: 0 auto;
  background-color: transparent;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
}

@media (max-width: 1024px) {
  .about-container {
    max-width: 100%;
    margin: 0;
  }
}

.about-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--color-black);
  margin-bottom: 30px;
  text-align: center;
}

.about-content {
  line-height: 1.7;
  color: var(--color-black);
  padding: var(--space-6);
  background: var(--color-surface);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-md);
}

.about-intro {
  font-size: 1.2rem;
  font-weight: 500;
  color: var(--color-black);
  margin-bottom: 25px;
  text-align: center;
  font-style: italic;
}

.about-content .typography {
  margin-bottom: 20px;
  font-size: 1rem;
}

.about-signature {
  margin-top: 40px;
  text-align: right;
}

.about-signature .typography {
  margin-bottom: 5px;
  font-style: italic;
  color: var(--color-gray-500);
}

.signature-name {
  font-weight: 600;
  color: var(--color-black) !important;
  font-size: 1.1rem;
}

/* Responsive design */
@media (max-width: 768px) {
  .about-page {
    padding: 0;
  }
  
  .about-container {
    max-width: 100%;
    margin: 0;
    padding: 0;
  }

  .about-content {
    padding: var(--space-4);
  }
  
  .about-title {
    font-size: 2rem;
  }
  
  .about-intro {
    font-size: 1.1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/About.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;EAChC,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".about-page {\n  padding: 0;\n  width: 100%;\n}\n\n.about-container {\n  max-width: 800px;\n  margin: 0 auto;\n  background-color: transparent;\n  border-radius: 0;\n  padding: 0;\n  box-shadow: none;\n}\n\n@media (max-width: 1024px) {\n  .about-container {\n    max-width: 100%;\n    margin: 0;\n  }\n}\n\n.about-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--color-black);\n  margin-bottom: 30px;\n  text-align: center;\n}\n\n.about-content {\n  line-height: 1.7;\n  color: var(--color-black);\n  padding: var(--space-6);\n  background: var(--color-surface);\n  border: 1px solid var(--color-border-subtle);\n  border-radius: var(--radius-md);\n}\n\n.about-intro {\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: var(--color-black);\n  margin-bottom: 25px;\n  text-align: center;\n  font-style: italic;\n}\n\n.about-content .typography {\n  margin-bottom: 20px;\n  font-size: 1rem;\n}\n\n.about-signature {\n  margin-top: 40px;\n  text-align: right;\n}\n\n.about-signature .typography {\n  margin-bottom: 5px;\n  font-style: italic;\n  color: var(--color-gray-500);\n}\n\n.signature-name {\n  font-weight: 600;\n  color: var(--color-black) !important;\n  font-size: 1.1rem;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .about-page {\n    padding: 0;\n  }\n  \n  .about-container {\n    max-width: 100%;\n    margin: 0;\n    padding: 0;\n  }\n\n  .about-content {\n    padding: var(--space-4);\n  }\n  \n  .about-title {\n    font-size: 2rem;\n  }\n  \n  .about-intro {\n    font-size: 1.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
